export const calcStatusDataSelector = ({ shared }) => shared.calcStatus.calcStatusData;
export const isFetchingCalcStatusSelector = ({ shared }) => shared.calcStatus.isFetchingCalcStatus;
